import { ErrorHandler, Injectable, InjectionToken, Injector } from "@angular/core";

@Injectable()
export class ErrorHandlerDistributor implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): any {
    const handlers = this.injector.get<ErrorHandler[]>(ERROR_HANDLERS, []);
    handlers.forEach((errorHandler: ErrorHandler) => {
      errorHandler.handleError(error);
    });
    console.error(error);
  }
}

export const ERROR_HANDLERS = new InjectionToken<ErrorHandler[]>("ERROR_HANDLERS");
export const errorHandlerDistributorProvider = {
  provide: ErrorHandler,
  useClass: ErrorHandlerDistributor,
};
